/** Zero-dep CSS confetti burst — 80 pieces, 3s cleanup. */
export default function fireConfetti() {
  const colors = ["#f97316", "#ec4899", "#a855f7", "#22c55e", "#3b82f6", "#eab308"];
  const container = document.createElement("div");
  container.setAttribute("data-testid", "confetti-container");
  Object.assign(container.style, {
    position: "fixed", inset: "0", pointerEvents: "none", zIndex: "9999", overflow: "hidden",
  });
  document.body.appendChild(container);
  const N = 80;
  for (let i = 0; i < N; i++) {
    const piece = document.createElement("div");
    const size = 6 + Math.random() * 8;
    const left = Math.random() * 100;
    const duration = 2 + Math.random() * 1.5;
    const delay = Math.random() * 0.5;
    const rotate = Math.random() * 360;
    const xEnd = (Math.random() > 0.5 ? 1 : -1) * (20 + Math.random() * 60);
    piece.style.setProperty("--x-end", `${xEnd}px`);
    Object.assign(piece.style, {
      position: "absolute", top: "-20px", left: `${left}%`,
      width: `${size}px`, height: `${size * 0.4}px`,
      background: colors[i % colors.length],
      transform: `rotate(${rotate}deg)`,
      animation: `acqxConfetti ${duration}s cubic-bezier(0.16,1,0.3,1) ${delay}s forwards`,
      opacity: "0.95",
    });
    container.appendChild(piece);
  }
  if (!document.getElementById("acqx-confetti-style")) {
    const s = document.createElement("style");
    s.id = "acqx-confetti-style";
    s.textContent = `@keyframes acqxConfetti {
      0%   { transform: translate3d(0,-20px,0) rotate(0deg); opacity: 1; }
      100% { transform: translate3d(var(--x-end,20px), 105vh, 0) rotate(720deg); opacity: 0.6; }
    }`;
    document.head.appendChild(s);
  }
  setTimeout(() => container.remove(), 3200);
}
